import { FormattedMessage, useIntl } from "react-intl";

import { DEFAULT_VALUES } from "@/libraries/web-framework";
import {
    EnhancedBannerAlert,
    EnhancedBannerProps
} from "@/patterns/adg4/enhanced-banner-alert/enhanced-banner-alert";
import { experiments, useExperiment } from "@/utils/experiment";

export const ConfluenceAboveNavButterbar = () => {
    const intl = useIntl();

    const gwp5090BannerExperiment = useExperiment(
        experiments.gwp5090ExperimentBannerConfluence
    );

    const gwp5090IsButterBar =
        gwp5090BannerExperiment != undefined &&
        gwp5090BannerExperiment.type === "enrolled" &&
        gwp5090BannerExperiment.value === "butterbar";

    const gwp5090Team25Config: EnhancedBannerProps = {
        identifier: "GWP5090.confluence-product-tour.butterbar",
        text: (
            <>
                <FormattedMessage
                    id="team25-banners-and-butterbars.confluence.text"
                    defaultMessage="<strong>April 8-10 • Anaheim, California</strong>Hear from the world&rsquo;s leading product experts on how to boost team performance at Team &rsquo;25!"
                    values={DEFAULT_VALUES}
                />
            </>
        ),
        mobileText: (
            <>
                <FormattedMessage
                    id="team25-banners-and-butterbars.confluence.mobile-text"
                    defaultMessage="<strong>April 8-10 • Anaheim, California</strong>Hear from leading product experts!"
                    values={DEFAULT_VALUES}
                />
            </>
        ),
        productKey: "home",
        backgroundPreset: "gwp-5090-banners",
        imageProps: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/4360jv8l7u81b0w6nn37fu86a2131624.webp",
            alt: "Team25", //Event name is not localized
            width: 200
        },
        linkText: intl.formatMessage({
            id: "team25-banners-and-butterbars.confluence.cta",
            defaultMessage: "Get your pass"
        }),
        linkUrl:
            "https://events.atlassian.com/team?utm_medium=event-web-referral&utm_source=confluence_product-tour&event_context=701QB00000Lg6oBYAR&utm_campaign=K:event|H:any|N:Team_25|P:agnostic|O:event-marketing|F:pre-event|C:event-home&utm_content=butterbar-banner_WEBTEAM-17396&event_id=216653",
        dataEventProps: {
            "data-product-key": "home",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": intl.formatMessage({
                id: "team25-banners-and-butterbars.confluence.cta",
                defaultMessage: "Get your pass"
            }),
            "data-label-english": "Get your pass"
        }
    };

    return gwp5090IsButterBar ? (
        <EnhancedBannerAlert {...gwp5090Team25Config} />
    ) : null;
};
